import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist({
  key: "pathologyReportPersistedState", // storage key
  storage: localStorage, // or sessionStorage
});
const getFormattedCurrentDate = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.toLocaleString("en-US", { month: "long" });
  const year = today.getFullYear();
  const formattedDay = day < 10 ? `0${day}` : day;

  return `${month} ${formattedDay}, ${year}`;
};
const getFormattedDate = () => {
  const today = new Date();
  return today.toISOString().split("T")[0];
};

export const pathologyReportsLoadedState = atom({
  key: "pathologyReportsLoadedState",
  default: false,
});

export const pathologyReportState = atom({
  key: "pathologyReportState",
  default: [],
});

export const rowLoadingState = atom({
  key: "pathologyRowLoadingState",
  default: false,
});

export const formattedFromDateState = atom({
  key: "pathologyFormattedFromDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const formattedToDateState = atom({
  key: "pathologyFormattedToDateState",
  default: getFormattedCurrentDate(),
  effects_UNSTABLE: [persistAtom],
});

export const fromDateState = atom({
  key: "pathologyFromDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});

export const toDateState = atom({
  key: "pathologyToDateState",
  default: getFormattedDate(),
  effects_UNSTABLE: [persistAtom],
});
